import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import StencilItem from './components/StenciItem';
import StencilType from './components/StencilType';
import StencilsSide from './components/StencilsSide';
import ProductDescription from './components/ProductDescription';
import GroupParameters from './components/group_parameters/GroupParameters';
import { changeParameter, validator } from './stencilSlice';

const Stencil = () => {
  // if no products/variants defined don't render anything
  if (!Spree.stencils_info || Spree.stencils_info.length === 0) {
    return null;
  }

  const dispatch = useDispatch();
  const {
    stencils,
    stencilsSide,
  } = useSelector((state) => state.smtStencil);

  const items = stencils.map((productItem, idx) => {
    const onChangeParameter = (name, value) => {
      dispatch(changeParameter({ name, value, ref: idx }))
    }
    return (
      <StencilItem
        key={idx}
        reference={idx}
        onChangeParameter={onChangeParameter}
        productItem={productItem}
        stencilsSide={stencilsSide}
        validator={validator} />
    )
  })

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <ProductDescription />
        </div>
        <div className="col-lg-3">
          <div className="stencil-type">
            <StencilType />
          </div>
        </div>
        <div className="col-lg-3">
          <div className="stencil-side">
            <StencilsSide />
          </div>
        </div>
        <div className="col-lg-6">
          <GroupParameters />
        </div>
      </div>
      {items}
    </div>
  );
}

export default Stencil;
